var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "trigger" }, [
    _c("div", {
      staticClass: "button",
      class: { bordered: _vm.activeFilters },
      domProps: { innerHTML: _vm._s(_vm.toggleLabel) },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "popup" }, [
      _c("div", { staticClass: "content" }, [_vm._t("default")], 2),
      _vm._v(" "),
      _c("div", { staticClass: "actions" }, [
        _c("a", {
          staticClass: "confirm",
          domProps: { innerHTML: _vm._s(_vm.labels.apply) },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }